import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import BarraProgresso from '../components/BarraProgresso';
import { useAuth } from '../contexts/AuthContext';
import api from '../api';

function TrilhaCard({ t }) {
  return (
    <Link to={`/academia/trilhas/${t.id}`} className="trilha-card">
      <div className="trilha-card-cab">
        <div className="trilha-card-titulo">{t.titulo}</div>
        {t.publicada === false && <span className="trilha-tag-rascunho">Rascunho</span>}
        {t.obrigatoria && <span className="trilha-tag-obrig">Obrigatória</span>}
      </div>
      {t.descricao && <div className="trilha-card-desc">{t.descricao}</div>}
      <BarraProgresso pct={t.pct} />
      <div className="trilha-card-rodape">
        {t.pct === 100
          ? <span className="trilha-concluida"><i className="bi bi-check-circle-fill"></i> Concluída</span>
          : <span>{t.concluidos}/{t.total} • {t.pct}%</span>}
      </div>
    </Link>
  );
}

export default function Academia() {
  const { temPermissao } = useAuth();
  const [trilhas, setTrilhas] = useState([]);
  const [carregando, setCarregando] = useState(true);

  useEffect(() => {
    api.get('/trilhas').then(({ data }) => setTrilhas(data.trilhas)).catch(() => {}).finally(() => setCarregando(false));
  }, []);

  const minhas = trilhas.filter(t => t.obrigatoria || t.atribuida);
  const catalogo = trilhas.filter(t => !(t.obrigatoria || t.atribuida));

  return (
    <>
      <Header />
      <main className="conteudo-container">
        <div className="doc-topo">
          <div>
            <h1 style={{ color: 'var(--verde)', fontWeight: 700, marginBottom: 4 }}>Academia</h1>
            <p style={{ color: 'var(--texto-suave)', margin: 0 }}>Trilhas e treinamentos pra você evoluir no Centrão.</p>
          </div>
          {temPermissao('gerir_academia') && (
            <div style={{ display: 'flex', gap: 8 }}>
              <Link to="/admin/quizzes" className="btn btn-outline-secondary"><i className="bi bi-patch-question me-1"></i> Quizzes</Link>
              <Link to="/admin/trilhas/nova" className="btn-centrao"><i className="bi bi-plus-lg me-1"></i> Nova trilha</Link>
            </div>
          )}
        </div>

        {carregando && <div>Carregando…</div>}

        {!carregando && trilhas.length === 0 && (
          <div className="conteudo-card" style={{ textAlign: 'center', padding: '40px 16px' }}>
            <i className="bi bi-mortarboard" style={{ fontSize: '2.5rem', color: 'var(--texto-suave)' }}></i>
            <p style={{ color: 'var(--texto-suave)', marginTop: 12 }}>Nenhuma trilha disponível ainda.</p>
          </div>
        )}

        {minhas.length > 0 && (
          <>
            <h2 className="trilha-secao">Minhas trilhas</h2>
            <div className="trilha-grid">{minhas.map(t => <TrilhaCard key={t.id} t={t} />)}</div>
          </>
        )}
        {catalogo.length > 0 && (
          <>
            <h2 className="trilha-secao">Catálogo</h2>
            <div className="trilha-grid">{catalogo.map(t => <TrilhaCard key={t.id} t={t} />)}</div>
          </>
        )}
      </main>
    </>
  );
}
